import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Reservation from '../views/Reservation.vue'
import SaveTemplate from '../views/SaveTemplateView.vue'
import Login from '../views/auth/Login.vue'
import Dashboard  from '../views/auth/Dashboard.vue'
import Register  from '../views/auth/Register.vue'
import Newprev  from '../views/auth/Newprev.vue'
import RistoMenu  from '../views/RistoMenu.vue'
import Preventivo  from '../views/Preventivo.vue'
import PreventivoMob  from '../views/PreventivoMob.vue'
import Contatto  from '../views/ContattoSito.vue'
import store from '../store'
import * as firebase from "firebase";

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/admin/dashboard'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  }, 
  {
    path: '/contatto',
    name: 'Contatto',
    component: Contatto
  },  
  {
    path: '/preventivo/:idreservation',
    name: 'preventivo',
    component: Preventivo,
    props: true
  }, 
  {
    path: '/preventivort/:idreservation',
    name: 'preventivo',
    component: PreventivoMob,
    props: true
  }, 
  {
    path: '/prev/:idreservation',
    name: 'Res',
    component: Home,
    props: true
  },  
  {
    path: '/admin/login',
    name: 'login',
    component: Login
  },  
  {
    path: '/admin/newprev',
    name: 'newprev',
    component: Newprev
  },  
  {
    path: '/admin/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },  
  {
    path: '/admin/register',
    name: 'register',
    component: Register
  },  
  {
    path: '/admin/saveastemplate',
    name: 'savetemplate',
    component: SaveTemplate,
    props: true,
    meta: {
      requiresAuth: true
    }
  },  
  {
    path: '/reservation',
    name: 'Reservation',
    component: Reservation
  },
  {
    path: '/ristomenu',
    name: 'Reservation',
    component: RistoMenu
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = store.state.user.data
  console.log('cu',from,to,currentUser)

  if (requiresAuth &&  !await firebase.getCurrentUser()) {
      next('/admin/login')
  } else if (requiresAuth && currentUser) {
      next()
  } else {
      next()
  }
})

export default router
